/**
 * 判断平台为移动端 or pc端
 */
export function checkPlatform(){
    let mobileflag = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i;
    let wechatflag = /(WeChat|Weixin)/i;
    if (wechatflag.test(navigator.userAgent)) {
      return 'wechat';
    } else if (mobileflag.test(navigator.userAgent)) {
      return 'mobile';
    } else {
      return 'pc';
    }
}

export function parseQuery(url=undefined, baseurl=undefined){
    if (!url) {url = window.location.href}
    const res = {};
    if (baseurl) {res['baseurl'] = url.split("?")[0] || "";}
    const query = (url.split("?")[1] || "")
      .trim()
      .replace(/^(\?|#|&)/, "");
    if (!query) {
      return res;
    }
    query.split("&").forEach(param => {
      const parts = param.replace(/\+/g, " ").split("=");
      const key = decodeURIComponent(parts.shift());
      const val = parts.length > 0 ? decodeURIComponent(parts.join("=")) : null;
  
      if (res[key] === undefined) {
        res[key] = val;
      } else if (Array.isArray(res[key])) {
        res[key].push(val);
      } else {
        res[key] = [res[key], val];
      }
    });
    return res
}



